const millions = {};
function currencyFormatDE(num, dec) {
  return num
    .toFixed(dec) // always two decimal digits
    .replace(".", ",") // replace decimal point character with ,
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
}

millions.install = function(Vue) {
  Vue.filter("number1", (v, d) => {
    if (d === 0) {
      v = parseInt(v);
    } else {
      v = parseFloat(v);
    }
    if (isNaN(v)) {
      v = 0;
    }
    return currencyFormatDE(v, d);
  });
  Vue.filter("number", (v, d) => {
    let v1;
    let v2;
    if (isNaN(parseInt(v))) {
      v = 0;
    } else {
      v1 = v;
      v2 = parseInt(v);
      v = parseInt(v);
    }
    v = v
      .toString()
      .split("")
      .reverse()
      .join("")
      .replace(/(?=\d*\.?)(\d{3})/g, "$1.");
    v = v
      .split("")
      .reverse()
      .join("")
      .replace(/^[.]/, "");
    let dec = v1 - v2;
    dec = dec * 100;
    dec = parseInt(dec);
    if (dec > 0) {
      if (d && d === "dec") {
        return `${v},${dec}`;
      } else {
        return v;
      }
    } else {
      if (d && d === "dec") {
        return `${v},00`;
      } else {
        return v;
      }
    }
  });
  Vue.filter("miles", (v) => {
    return `${v} miles`;
  });
  Vue.filter("textempresa", (v) => {
    let text;
    if (v) {
      if (v.length > 19) {
        text = v.substr(0, 16) + "...";
      } else {
        text = v;
      }
      return text;
    }
  });
  Vue.filter("agryear", (v) => {
    if (v) {
      if (v === "AGR-year") {
        return "AÑO";
      } else if (v === "year") {
        return "AÑO";
      } else if (v.substr(0, 4) === "AGR-") {
        return v.substr(4, v.length);
      } else {
        return v;
      }
    }
  });
  Vue.filter("textnumber", (v, d) => {
    const formatter = new Intl.NumberFormat("es-AR", {
      minimumFractionDigits: d,
    });
    const init = v;
    if (d === 0) {
      v = parseInt(v);
    } else {
      if (d === 1) {
        v = parseInt(parseFloat(v) * 10);
        v = v / 10;
      } else if (d === 2) {
        v = parseInt(parseFloat(v) * 100);
        v = v / 100;
      } else {
        v = parseFloat(v);
      }
    }
    if (isNaN(v)) {
      return init;
    } else {
      return formatter.format(v);
    }
  });
  Vue.filter("agregaTilde", (v) => {
    let r;
    if (v === "Autoevaluacion") {
      r = "Autoevaluación";
    } else {
      r = v;
    }
    return r;
  });
  Vue.filter("agregarTilde", (v) => {
    let r;
    if (v === "demograficos") {
      r = "Demográficos";
    } else {
      r = v;
    }
    return r;
  });
};

export default millions;



// WEBPACK FOOTER //
// ./src/filters/numbers.js